<template>
  <section id="home" class="hero-section">
    <v-parallax height="800">
      <v-img
       :src="heroImage"
       height="800"
       cover
       position="top"
      >
      <div
      style="position:absolute;bottom:0;
        width:100%;
        height:100%;
        background:linear-gradient(
          to bottom,
          rgba(0,0,0,0.10) 20%,
          rgba(0,0,0,0.90) 100%
        );"></div>

        <navbar-component  @is-navbar-icon-active="handleNavbarIconActive" />
        <v-row class="fill-height justify-center align-center">
          <v-col cols="12" class="text-center">
            <h1 class="text-h2 font-weight-bold white--text mb-4">
              CAPTURING MOMENTS THAT LAST FOREVER
            </h1>
            <h2 class="text-h5 white--text mb-6">
              Professional Photography for Every Occasion
            </h2>
            <v-btn x-large color="primary" >
              View Portfolio
              <v-icon right>mdi-arrow-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-img>
    </v-parallax>
  </section>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarComponent from './NavbarComponent.vue';

export default defineComponent({
  name: 'HomeComponent',

  components: {
    NavbarComponent,
  },
  data() {
    return {
      //heroImage: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
      isNavbarIconActive: false,
      heroImage: require('../assets/background-image.jpg')

    };
  },
  methods: {
    handleNavbarIconActive(isNavbarIconActive: boolean): void {
      this.isNavbarIconActive = isNavbarIconActive;
    }

  },
  emits: ['explore-portfolio']
})
</script>

<style scoped>
.hero-section {
  margin-top: -64px;
}

@media (max-width: 960px) {
  
  .text-h2 {
    font-size: 2rem !important;
  }
}
</style>